module.exports = __webpack_public_path__ + "img/p34.47817e1c.jpg";